// extracted by mini-css-extract-plugin
export default {"innerPriceUpdater":"InnerPriceUpdater_innerPriceUpdater__aU1ge"};